export type SortOrder = 'asc' | 'desc';

export interface ListSort {
  sortBy?: string;
  sortOrder?: SortOrder;
}

/**
 * The next sort after clicking a column header: a new column starts at its
 * natural direction (names A→Z, money and dates newest/highest first), the
 * second click flips it, the third goes back to the list's default order.
 */
export function nextSort(
  current: ListSort,
  column: string,
  firstOrder: SortOrder = 'asc'
): ListSort {
  if (current.sortBy !== column) {
    return { sortBy: column, sortOrder: firstOrder };
  }
  const order = current.sortOrder ?? firstOrder;
  if (order === firstOrder) {
    return { sortBy: column, sortOrder: order === 'asc' ? 'desc' : 'asc' };
  }
  return { sortBy: undefined, sortOrder: undefined };
}
